/**
 * Menu Services - API service layer for menu and navigation operations
 * Handles retrieval of menu items, user-specific menus, and menu details for navigation
 */
import axios from "axios";

// API URL configuration for user/menu endpoints
const API_URL = process.env.REACT_APP_API_URL + "users";

/**


 * Purpose: Retrieve all available menu items from the system
 * @returns {Object} All menu items in the system
 */
export async function getAllMenu() {
  let url = `${API_URL}/menu`;
  const response = await axios
    .get(url)
    .then(function (resp) {
      return resp;
    })
    .catch(function (error) {
      return { message: "Unable to find request", status: false };
    });
  return response.data;
} 

/**

 * Purpose: Retrieve menu items filtered by user role and device type
 * @param {string} role - User role for menu filtering
 * @param {string} device - Device type (mobile/desktop) for menu filtering
 * @returns {Object} Role and device-specific menu items
 */
export async function getUserMenu(role, device) {
  console.log("getuserrle", sessionStorage.getItem("token"));
  let url = `${API_URL}/menu/getmenu`;
  const response = await axios
    .post(url, { Role: role, Device: device })
    .then(function (resp) {
      console.log(resp);
      return resp;
    })
    .catch(function (error) {
      console.log(error);
      return { message: "Unable to find request", status: false };
    });
  return response.data;
} 

/**
 *

 * Purpose: Extract menu details (title, buttons, etc.) for a specific route/pathname
 * @param {string} getmenudata - JSON string containing menu data
 * @param {string} pathname - Current route pathname to find menu details for
 * @returns {Object|undefined} Menu details object with title, button, currentMenu, etc.
 * 
 * Functionality:
 *   - Converts root path "/" to "/dashboard"
 *   - Parses menu data JSON string
 *   - Filters menu items by pathname
 *   - Returns structured menu details for UI rendering
 */
 export function getMenuDetails(getmenudata, pathname) {
  if (pathname == "/")
    pathname = "/dashboard"
  if (getmenudata) {
    let menudata = JSON.parse(getmenudata);
    // Clear any potential caching by creating fresh filter
    let screen = menudata.filter((i) => i.menu_path === pathname);
    if (screen && screen.length > 0 && screen[0]) {
      return {
        title: screen[0].menu_name,
        button: screen[0].menu_button,
        buttontext: screen[0].menu_button_name,
        currentMenu: screen[0].menu_group,
        path: pathname,
        heading: screen[0].menu_heading && screen[0].menu_name,
      };
    }
  }
  return undefined;
} 